import { cn } from "@/lib/utils";

// Marca de agua: Santiago en línea — la cordillera detrás y la ciudad adelante, con la Gran Torre
// y la torre Entel como las dos siluetas que cualquier santiaguino reconoce. Es un dibujo propio en
// SVG (no una foto de stock): pesa nada, escala sin perder nitidez y toma el color del contexto por
// `currentColor`, así que la misma pieza sirve sobre la franja oscura y sobre fondo claro.
//
// Decoración pura: `aria-hidden` y `pointer-events-none`. La opacidad la decide quien la usa.

// [x, ancho, alto] de cada edificio sobre la línea de base (y = 300).
const EDIFICIOS = [
  [0, 46, 70], [50, 34, 105], [88, 52, 82], [144, 30, 128], [178, 58, 96], [240, 36, 150],
  [280, 48, 112], [332, 28, 88], [364, 62, 134], [430, 40, 102], [474, 30, 76],
  [560, 44, 118], [608, 56, 142], [668, 36, 96], [708, 30, 120],
  [800, 50, 138], [854, 34, 104], [892, 60, 160], [956, 38, 92], [998, 52, 126],
  [1054, 30, 84], [1088, 58, 112], [1150, 50, 90],
];

// Ventanas: una línea horizontal cada 14px en los edificios de más de 100px.
const ventanas = (x, w, h) => {
  const lineas = [];
  for (let y = 300 - h + 14; y < 292; y += 14) lineas.push(`M${x + 6} ${y}H${x + w - 6}`);
  return lineas.join("");
};

export const MarcaDeAgua = ({ className }) => (
  <svg
    className={cn("pointer-events-none absolute inset-x-0 bottom-0 w-full", className)}
    viewBox="0 0 1200 300"
    preserveAspectRatio="xMidYMax slice"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {/* Cordillera */}
    <path d="M0 175 L70 128 L120 150 L200 74 L262 118 L330 66 L402 122 L470 92 L540 136 L612 58 L690 112 L770 80 L842 128 L918 70 L990 116 L1062 86 L1130 124 L1200 96" />
    {/* Nieve: sólo en las cumbres más altas */}
    <path d="M186 88 L200 74 L214 90 M318 80 L330 66 L344 82 M598 72 L612 58 L628 74 M904 84 L918 70 L932 86" />

    {EDIFICIOS.map(([x, w, h]) => (
      <g key={x}>
        <rect x={x} y={300 - h} width={w} height={h} />
        {h > 100 && <path d={ventanas(x, w, h)} strokeWidth="0.8" />}
      </g>
    ))}

    {/* Torre Entel: fuste, plataforma y antena */}
    <path d="M512 300 V150 M528 300 V150 M504 150 H536 M508 142 H532 L528 150 M512 142 L516 128 H524 L528 142 M520 128 V70" />
    {/* Gran Torre Santiago: prisma con remate afilado */}
    <path d="M740 300 V78 L752 52 H778 L790 78 V300 M752 52 L765 20 L778 52 M740 78 H790" />
    <path d={ventanas(740, 50, 222)} strokeWidth="0.8" />

    <path d="M0 300 H1200" />
  </svg>
);
